<ds-overlay
  [attr.modal-size]="'medium'"
  [attr.icon-extra]="iconExtra"
  [attr.overlay-icon]="overlayIcon"
  [attr.overlay-description-id]="'descrizione_overlay'"
  [attr.is-gradient-color]="false"
  [attr.has-blur]="true"
  (closeModal)="onNoClick()">
  <div slot="title">
    <h2
      class="  ff-title-s ff-bold"
      style="margin: 0"
      id="overlay-title">
      {{ data.title }}
    </h2>
  </div>
  <div slot="text">
    <p
      class="  ff-body-l ff-regular"
      id="overlay-description"
      style="margin-bottom: 1.5rem; padding-top: 0.75rem !important"
      [innerHTML]="data.message">
    </p>
  </div>
  <div
    slot="footer"
    style="
      display: flex;
      gap: 0.5rem;
      align-items: center;
      justify-content: end;
    ">
    <ds-button
      [attr.button-type]="'secondary'"
      [attr.button-ui-variant]="'secondary'"
      [attr.button-size]="'medium'"
      [attr.button-label]="'ordini.cancel' | translate"
      (onClickEvent)="onNoClick()"></ds-button>

    <ds-button
      [attr.button-type]="'primary'"
      [attr.button-size]="'medium'"
      [attr.button-label]="'ordini.confirm' | translate"
      (onClickEvent)="confirmChoice(true)"></ds-button>
  </div>
</ds-overlay>
